// BIG BLACK HORSE - Simple Quantity Script - NEW VERSION
(function() {
  'use strict';

  function initBBHQuantity() {
    const productForms = document.querySelectorAll('product-form form[action*="/cart/add"]');
    
    productForms.forEach(form => {
      // Skip if already initialized
      if (form.querySelector('.bbh-qty-new-wrapper')) return;

      const submitButton = form.querySelector('.product-form__submit');
      const quantityInput = form.querySelector('input[name="quantity"]');
      
      if (!submitButton || !quantityInput) return;

      // Create wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'bbh-qty-new-wrapper';

      // Minus button
      const minusBtn = document.createElement('button');
      minusBtn.type = 'button';
      minusBtn.className = 'bbh-qty-new-btn minus';
      minusBtn.innerHTML = '−';

      // Plus button
      const plusBtn = document.createElement('button');
      plusBtn.type = 'button';
      plusBtn.className = 'bbh-qty-new-btn plus';
      plusBtn.innerHTML = '+';

      // Badge
      const badge = document.createElement('span');
      badge.className = 'bbh-qty-new-badge';
      badge.textContent = '1';

      // Clone submit button
      const newSubmit = submitButton.cloneNode(true);
      newSubmit.classList.add('bbh-qty-new-integrated');
      newSubmit.appendChild(badge);

      // Build
      wrapper.appendChild(minusBtn);
      wrapper.appendChild(newSubmit);
      wrapper.appendChild(plusBtn);

      // Replace
      submitButton.parentNode.replaceChild(wrapper, submitButton);

      // Quantity logic
      let qty = 1;
      quantityInput.value = qty;

      function update() {
        minusBtn.disabled = qty <= 1;
        badge.textContent = qty;
        
        if (qty > 1) {
          badge.classList.add('active');
        } else {
          badge.classList.remove('active');
        }

        const span = newSubmit.querySelector('span:not(.bbh-qty-new-badge)');
        if (span) {
          if (qty === 1) {
            span.textContent = span.dataset.orig || 'Add to cart';
          } else {
            if (!span.dataset.orig) span.dataset.orig = span.textContent;
            span.textContent = `Add ${qty} to cart`;
          }
        }
      }

      minusBtn.addEventListener('click', () => {
        if (qty > 1) {
          qty--;
          quantityInput.value = qty;
          update();
          badge.classList.add('pulse');
          setTimeout(() => badge.classList.remove('pulse'), 300);
        }
      });

      plusBtn.addEventListener('click', () => {
        qty++;
        quantityInput.value = qty;
        update();
        badge.classList.add('pulse');
        setTimeout(() => badge.classList.remove('pulse'), 300);
      });

      form.addEventListener('submit', () => {
        setTimeout(() => {
          qty = 1;
          quantityInput.value = qty;
          update();
        }, 1000);
      });

      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBBHQuantity);
  } else {
    initBBHQuantity();
  }

  document.addEventListener('shopify:section:load', initBBHQuantity);
})();
